import { Link } from 'gatsby';
import React from 'react';
import { CategoriesContext } from '../../../contexts';
import { BreadCrumb } from '../../../types/BreadCrumb';
import { parseLink } from '../../../utils/parseLink';
import { BreadCrumb as BreadCrumbComponent } from '../../atoms/breadCrumb';
import './breadCrumbs.scss';

export type BreadCrumbsProps = {
  categoryBreadCrumb: BreadCrumb;
  tagsBreadCrumbs: BreadCrumb[];
};

export const BreadCrumbs: React.FC<BreadCrumbsProps> = ({
  categoryBreadCrumb,
  tagsBreadCrumbs,
}) => {
  const { getColorForCategory } = React.useContext(CategoriesContext);
  const CATEGORY_COLOR = getColorForCategory(categoryBreadCrumb.name ?? '');
  const categoryBreadCrumbComponent = (
    <BreadCrumbComponent
      label={categoryBreadCrumb.name ?? ''}
      color={CATEGORY_COLOR}
      isRoot
    />
  );
  return (
    <div className="breadcrumbs">
      {categoryBreadCrumb.link ? (
        <Link to={parseLink(categoryBreadCrumb.link)}>
          {categoryBreadCrumbComponent}
        </Link>
      ) : (
        categoryBreadCrumbComponent
      )}

      {tagsBreadCrumbs.map((breadCrumb: BreadCrumb) => (
        <BreadCrumbComponent
          key={breadCrumb.name ?? ''}
          label={breadCrumb.name ?? ''}
        />
      ))}
    </div>
  );
};
